import auth from './api-url/auth'
import user from './api-url/user'
import company from './api-url/company'
import driver from './api-url/driver'
import vehicle from './api-url/vehicle'
import supply from './api-url/supply'
import settings from './api-url/settings'
import order from './api-url/order/index'
import booking from './api-url/booking'
import area from './api-url/area'
import companyGroup from './api-url/company-group'
import system from './api-url/system'
import commodity from './api-url/commodity'
import speedAssumptions from './api-url/speed-assumptions'
import salaryAssumptions from './api-url/salary-assumptions'
import customer from './api-url/customer'
import vendor from './api-url/vendor'
import companyBranch from './api-url/company-branch'
import notification from './api-url/notification'
import partner from './api-url/partner'
import cost from './api-url/cost'
import workflow from './api-url/workflow'
import routing from './api-url/routing'
import price from './api-url/price'
import quote from './api-url/quote'
import statistic from './api-url/statistic'
import activities from './api-url/activities'
import trip from './api-url/trip'
import analysis from './api-url/analysis'
import utils from './api-url/utils'
import journey from './api-url/journey'
import monitoring from './api-url/monitoring'
import report from './api-url/report'
import dashboard from './api-url/dashboard'
import route from './api-url/route'
import shared from './api-url/shared'

export default {
  auth,
  user,
  company,
  driver,
  vehicle,
  supply,
  settings,
  order,
  booking,
  area,
  companyGroup,
  system,
  commodity,
  speedAssumptions,
  salaryAssumptions,
  customer,
  companyBranch,
  notification,
  vendor,
  partner,
  cost,
  workflow,
  routing,
  price,
  quote,
  statistic,
  activities,
  trip,
  analysis,
  utils,
  journey,
  monitoring,
  report,
  dashboard,
  route,
  shared
}
